module.exports = {
  LIST_FOODS: 'list_foods',
  SET_CART_COUNT: 'set_cart_counts',
  SET_CURRENT_CART: 'set_current_cart_IDs',
};
